export default __webpack_public_path__ + "ruby-on-rails.6f466c72.png";